import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Entaggling the word",
  "description": "",
  "published": "2007-12-31T00:00:00.000Z",
  "redirect_from": ["/blog/entaggling-the-word/swizec/138"],
  "hero": "./img/2134-2151766174_8cf0f70de0_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday was far more productive than it should be (in that I did nearly everything other than studying as I was supposed to). My pet project that is destined to launch me into the rich and powerful stratosphere (looking from the perspective of a worm) `}<a parentName="p" {...{
        "href": "http://urbanislovar.org/"
      }}>{`urbanislovar.org`}</a>{` has finally received that final significant boost into marginal usability it was waiting for since something like October or even September.`}</p>
    <p>{`That's right, tags have been added. Each word can be tagged by any user of the website and a tagcloud is formed that shows the importance of a tag. Basically its size shows how oft said word has been tagged by a certain tag and the tag's opacity shows to how many different words it pertains. All in all a very useful tool and it even managed to look quite attractive. I'm almost proud.`}</p>
    <p>{`I say this is the final boost into marginal usability because the project has finally reached a stage where I will not erase the database anymore, which I did often before because the structure would change and testing was going on and stuff. It also got transfer to a real host, because everyone tries harder once they're paying for the hosting of a project ... especially myself.`}</p>
    <p>{`So in the next few weeks or, which is more probable, months the project will slowly take on new features and reach to that final stage where it can begin being properly advertised with a campaign I've been planning since autumn. I think it's safe to say the project will be officially launched come May.`}</p>
    <p>{`And here's what the tags look like:`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/swiz/2151766174/",
        "title": "sexnakolesih7 by swizec _, on Flickr"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "76.68161434977578%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'307\\'%20viewBox=\\'0%200%20400%20307\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%207c-4%203-4%206%200%206%202%200%206%203%206%205l-6%201c-6%200-8-1-5-4%201-1%200-3-3-2l-2%201-1%201c-2%200-8%204-8%206H2c0-1%200-2-1-1L0%2034v14h30l31%201%201%20128a7464%207464%200%20003%20130l1-127V46h116l116%201v130l1%20130c1-1%202-28%202-130l1-128%2049-1%2050-1V19h-69a94674%2094674%200%2001-79-1c0-2-3-3-7-3l-3-1%209-1h8l-13-1c-13%200-16%201-16%205l1-1%203-2%202-1c2%200%202%200%202%203l-1%203H36l-4-4c-2-3-3-4-3-7%201-5-2-5-7-1M9%2018c-3%202-4%204-1%204%202-1%203%200%206%206l5%208%202%202c5%204%2016-2%2016-8%200-3%200-3-1-1%200%203-4%207-7%207-2%200-9-5-9-7l-3-5-3-6c0-2%200-2-5%200m222%2010v7l1%205h104l1-5c2-9%206-8-53-8l-53%201m-86%2048l-1%201-3%201-2-1h-4c-1%201-2%200-3-1h-2l-3%201h-15l-1%204c0%204%203%204%203%200l1-2v2l1%203%202-3%201-2v2c0%203%200%203%205%203%204%200%205-1%205-3l1-2v2c0%203%201%205%202%203h8c8%200%209-1%207-7-1-3-1-3-2-1m23%200c0%202-1%203-2%201h-6l-5-1-1-1c-2%200-2%201-2%205s0%204%203%204c2%200%203%200%203-2%200-3%202-3%202-1%201%203%206%204%207%202h1l3%201%203-1h1c2%201%2014%201%2014-1h-2l-2-1%202-2%202-1c0-1-3-2-5-1h-7c-2%201-6%200-6-2-1-2-3-1-3%201m-52%2020h-2c-1-2-12-1-12%202h-1c0-2-2-2-3%200%200%203%202%204%2011%204h13l3-2c1-4%201-5-1-5l-2%201h-2c-2-2-2-2-4%200m18%2037l-2%202c1%202%2023%203%2028%201h40v-2c0-2-10-1-11%200h-1a72%2072%200%2000-27-1h-27m27%2018l-7%201a107%20107%200%2000-31%201l-8-1c-10-1-16%200-15%202l45%201c18%200%2019%200%2019-2s-1-3-3-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/673d24c5f257e54749e5517ad92b1830/ca0a1/2134-2151766174_8cf0f70de0_m.webp 223w", "/static/673d24c5f257e54749e5517ad92b1830/8ac56/2134-2151766174_8cf0f70de0_m.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/673d24c5f257e54749e5517ad92b1830/853b2/2134-2151766174_8cf0f70de0_m.jpg 223w", "/static/673d24c5f257e54749e5517ad92b1830/09b79/2134-2151766174_8cf0f70de0_m.jpg 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/673d24c5f257e54749e5517ad92b1830/09b79/2134-2151766174_8cf0f70de0_m.jpg",
                "alt": "sexnakolesih7",
                "title": "sexnakolesih7",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`sexnakolesih7`}</figcaption>{`
  `}</figure></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      